import { useState } from "react";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { RegisterModalFooter } from "..";

function CSRFoundation({ csrFoundationState, setCsrFoundationState, registerUser, email, setOpen }) {
    const [selected, setSelected] = useState(false);
    let { csrFoundationName, csrContributionCategories, csrPointOfContact, csrAddress, csrRepresentativeRole } = csrFoundationState;

    const handleCsrFoundationChange = (e) => {
        if (e.target.value.indexOf("All Categories") > -1) {
            setCsrFoundationState((prevState) => ({
                ...prevState,
                [e.target.name]: csrContributionCategories.length !== 0 ? [] : all_projects.map((option) => option),
            }));
        } else {
            setCsrFoundationState((prevState) => ({
                ...prevState,
                [e.target.name]: e.target.value,
            }));
        }
    };
    const handleClick = (e) => {
        if (csrContributionCategories.length === all_projects.length) {
            setSelected(false);
            e.stopPropagation();
        } else {
            setSelected(true);
        }
    };
    console.log(selected);
    const all_projects = [
        "Agriculture",
        "Community",
        "Education",
        "Environment",
        "HealthCare",
        "Housing",
        "InfraStructurePower",
        "Roads and Bridges",
        "Social Justice",
        "Technology",
        "Waste Management",
        "Water & Sanitization",
        "Others",
    ];

    const handleBackClick = () => {
        setOpen("usertype");
    };

    const handleForwardClick = () => {
        if (!csrFoundationName || csrContributionCategories.length === 0 || !csrPointOfContact || !csrAddress || !csrRepresentativeRole) {
            return alert("please fill all CSR foundation  details");
        }
        registerUser();
    };
    return (
        <Grid item xs={12} className="common-modal__container" container direction="column" justifyContent="flex-start" alignItems="flex-start">
            <h3>
                Sign up as <span className="span-text">CSR Foundation.</span>
            </h3>
            <Grid item xs={12} className="field__grid" container justifyContent="space-between" alignItems="center" mb="15px">
                <TextField
                    variant="standard"
                    label="Foundation Name"
                    className="input__field"
                    fullWidth
                    type="text"
                    name="csrFoundationName"
                    value={csrFoundationName}
                    onChange={handleCsrFoundationChange}
                />
                <TextField variant="standard" className="input__field" fullWidth type="text" name="csrEmail" disabled value={email} />
            </Grid>

            <Grid item xs={12} className="field__grid" container justifyContent="space-between" alignItems="center" mb="15px">
                <FormControl variant="standard" sx={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-standard-label">Focus of Interest</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-multiple-name"
                        multiple
                        value={csrContributionCategories}
                        name="csrContributionCategories"
                        onChange={handleCsrFoundationChange}
                    >
                        <MenuItem
                            value={"All Categories"}
                            onClick={handleClick}
                            style={selected ? { backgroundColor: "rgba(25, 118, 210, 0.08)" } : {}}
                        >
                            All Categories
                        </MenuItem>
                        {all_projects.map((name) => (
                            <MenuItem key={name} value={name}>
                                {name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    variant="standard"
                    label="Contact"
                    className="input__field"
                    fullWidth
                    onKeyPress={(event) => {
                        // ignore "-", "+" and "e"
                        if (event?.key === "-" || event?.key === "+" || event?.key === "e") {
                            event.preventDefault();
                        }
                        // if character is not number then ignore except decimal point and
                        if (event?.key !== "." && event?.key && isNaN(+event.key)) {
                            event.preventDefault();
                        }
                        if (event.target.value.length >= 10) {
                            event.preventDefault();
                        }
                    }}
                    InputProps={{
                        maxLength: 10,
                    }}
                    type="text"
                    name="csrPointOfContact"
                    value={csrPointOfContact}
                    onChange={handleCsrFoundationChange}
                />
            </Grid>

            <Grid item xs={12} className="field__grid" container justifyContent="space-between" alignItems="center" mb="15px">
                <TextField
                    variant="standard"
                    label="Address"
                    className="input__field"
                    fullWidth
                    type="text"
                    name="csrAddress"
                    value={csrAddress}
                    onChange={handleCsrFoundationChange}
                />
                <TextField
                    variant="standard"
                    label="Representative Role"
                    className="input__field"
                    fullWidth
                    type="text"
                    name="csrRepresentativeRole"
                    value={csrRepresentativeRole}
                    onChange={handleCsrFoundationChange}
                />
            </Grid>

            <Grid item xs={12} container direction="row" justifyContent="space-between" alignItems="center" className="button__container">
                <Button className="back__btn" type="button" onClick={handleBackClick}>
                    Back
                </Button>
                <Button className="continue__btn" type="button" onClick={handleForwardClick}>
                    Save and continue
                </Button>
            </Grid>
            <RegisterModalFooter />
        </Grid>
    );
}

export default CSRFoundation;
